export default {
      id: "pay_visa-usage",
      viewBox: "0 0 56 19",
      url: __webpack_public_path__ + "sprite.svg#pay_visa",
      toString: function () {
        return this.url;
      }
    }